const AccountStatuses = Object.freeze({
  LOCKED: "locked",
  UNLOCKED: "unlocked",
  DEFAULT: "default",
});

export default AccountStatuses;
